import React, { Component } from "react";
import PropTypes from "prop-types";
import ModalDialog from "../../controls/ModalDialog.jsx";
import InputError from "../../controls/InputError.jsx";
import CapsLockDetector from "../../utilities/CapsLockDetector";
import ErrorResponse from "newApp/components/SelectorPages/ErrorResponse";
import { isEnterPressed } from "newApp/utilities/EventsHelper";


export class SiteSetupNewLinkDialog extends Component {
    constructor (props) {
        super(props);

        this.state = {
            currentSite: props.currentSiteId,
            currentLogin: "",
            currentPassword: "",
            capsLock: false
        };

        this.onSiteChanged = this.onSiteChanged.bind(this);
        this.onLoginChanged = this.onLoginChanged.bind(this);
        this.onPasswordChanged = this.onPasswordChanged.bind(this);
        this.onSave = this.onSave.bind(this);
        this.handlePasswordKeyPress = this.handlePasswordKeyPress.bind(this);
        this.modalDialogContent = this.modalDialogContent.bind(this);
        this.onCheckSiteId = this.onCheckSiteId.bind(this);
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.onSave();
        }
    }

    onSiteChanged (event) {
        this.setState({ currentSite: event.target.value });
    }

    onLoginChanged (event) {
        this.setState({ currentLogin: event.target.value });
    }

    onPasswordChanged(event) {
        this.setState({ currentPassword: event.target.value });
    }

    handlePasswordKeyPress (e) {
        if (CapsLockDetector(e)) {
            this.setState({ capsLock: this.state.capsLock });
        }
    }

    onSave () {
        const state = this.state;
        this.props.onSave(state.currentSite, state.currentLogin, state.currentPassword);
    }

    onCheckSiteId () {
        this.props.onCheckSiteId(this.state.currentSite);
    }

    modalDialogContent () {
        const capsLock=this.state.capsLock && this.state.currentPassword !== "";
        return (
            <div id="SiteSetupNewLink">
                <div className="login-row siteid-login-row row">
                    <div className="formControlTitle col-md-2" style={{ display: "table-caption" }}>Site ID</div>
                    <input onChange={this.onSiteChanged}
                        tabIndex="1"
                        autoFocus="true"
                        className="picker-hollow col-md-2"
                        value={this.state.currentSite}
                        id="siteId"
                        type="text"
                        onKeyUp={this.handleEnterKey}
                        onBlur={this.onCheckSiteId}/>
                </div>
                <div className="login-row" />

                <div className="login-row userIdDivClass row">

                    <div className="formControlTitle col-md-2">User ID</div>
                    <input tabIndex="2"
                        id="loginId"
                        onChange={this.onLoginChanged}
                        onKeyUp={this.handleEnterKey}
                        className="picker-hollow col-md-9"
                        type="text"/>
                </div>

                <div className="login-row passwordDivClass row">
                    <div className="formControlTitle col-md-2">Password</div>
                    <input tabIndex="3"
                        id="password"
                        className="picker-hollow col-md-9"
                        onChange={this.onPasswordChanged}
                        onKeyUp={this.handleEnterKey}
                        onKeyPress={this.handlePasswordKeyPress}
                        type="password"/>
                </div>
                <div className="login-row">
                    <InputError label="CAPS Lock Is ON" visible={capsLock}/>
                </div>

                <ErrorResponse error = {this.props.impersonateError} title={"Linking Failed"} />
            </div>
        );
    }

    render () {
        const buttons = [{
            bsStyle: "default",
            cssClass: "btn btn-default",
            onClick: () => this.props.onCancel(),
            tabIndex: "6",
            key: "cancel",
            text: "Cancel"
        }, {
            bsStyle: "primary",
            cssClass: "btn btn-primary-action",
            onClick: () => this.onSave(),
            tabIndex: "8",
            key: "save",
            text: "Save"
        }];
        return (
            <ModalDialog id="SiteSetupNewLinkDialog"
                title="Site Setup"
                content={this.modalDialogContent()}
                buttons={buttons}
                onDocumentClose={this.props.onCancel}
                show={this.props.show}/>
        );
    }
}

SiteSetupNewLinkDialog.defaultProps = {
    currentSiteId: "",
    impersonateError: "",
    show: false
};

SiteSetupNewLinkDialog.propTypes = {
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    onCheckSiteId: PropTypes.func,
    impersonateError: PropTypes.any,
    currentSiteId: PropTypes.any,
    show: PropTypes.bool
};

export default SiteSetupNewLinkDialog;
